import React, { useState, useEffect } from 'react';
import { useScrollLock } from '../../_utils/useScrollLock';
import ReactDOM from 'react-dom';
import CloseButton from '../shared/CloseButton';
import { walletService } from '../../_services/wallet.service';
import { normalizeGiftCard } from './useWallet';
import './Wallet.css';

// AddGiftCardModal — claim a gift card by code (e.g. from an in-salon receipt or
// a gift email) and bind it to the wallet. On success, the (normalized) card is
// handed back so the wallet can show it and, if it has no design, prompt to
// choose one.
const AddGiftCardModal = ({ onClose, onClaimed }) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  // Shared ref-counted lock: overlapping modals must not restore each
  // other's locked styles (see SalonProfilePage/ConfirmBookingModal).
  useScrollLock(true);

  const submit = () => {
    const c = code.trim();
    if (!c || busy) return;
    setBusy(true);
    setError(null);
    walletService.claimGiftCard(c)
      .then((card) => { onClaimed && onClaimed(normalizeGiftCard(card)); })
      .catch(() => { setError('We could not find a gift card with that code.'); setBusy(false); });
  };

  return ReactDOM.createPortal(
    <div className="wallet-modal-overlay" onClick={onClose}>
      <div className="wallet-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label="Add a gift card">
        <header className="wallet-modal-header">
          <h2 className="wallet-modal-title">Add a gift card</h2>
          <CloseButton onClick={onClose} />
        </header>

        <div className="wallet-modal-body">
          <p className="cd-sub">Enter the code from your gift card or email and we will add it to your wallet.</p>
          <input
            className="wac-input"
            value={code}
            placeholder="e.g. BEU-GIFT-2654"
            onChange={(e) => { setCode(e.target.value); setError(null); }}
            onKeyDown={(e) => e.key === 'Enter' && submit()}
            aria-label="Gift card code"
            autoFocus
          />
          {error && <p className="wac-error">{error}</p>}
        </div>

        <div className="wallet-modal-footer">
          <button type="button" className="wallet-cta" disabled={!code.trim() || busy} onClick={submit}>
            {busy ? 'Adding…' : 'Add gift card'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AddGiftCardModal;
